import React from 'react';
import { useRouter } from 'next/router';
import { DashboardLayout, PageCard } from '@vette/ui-components';
import { useUserQuery } from '@vette/data-access';
import { useVetterDisclaimer } from '../../common/hooks/useVetterDisclaimer';
import { StripeAccountSettings } from './StripeAccountSettings';

type Props = {
  userId: string;
};

export const PayoutsPage: React.FC<Props> = ({ userId }: Props) => {
  const router = useRouter();
  const showDisclaimer = useVetterDisclaimer();

  const { data, loading } = useUserQuery({
    variables: {
      userId,
    },
    onCompleted: ({ user }) => {
      if (user?.__typename === 'User') {
        !user?.onboardingCompleted && router.replace('/terms');
        showDisclaimer(user);
      }
    },
  });

  return (
    <DashboardLayout loading={loading} hasStatusToggle>
      <PageCard title="Payouts">
        <StripeAccountSettings
          viewOnly={!data?.user?.isProfileDataProvided}
          userId={userId}
          stripeAccountConnected={
            data?.user?.stripeUser?.stripeAccountConnected
          }
        />
      </PageCard>
    </DashboardLayout>
  );
};
